// removed by extract-text-webpack-plugin
module.exports = {"studentInfo-float":"studentInfo-float","header":"header","icon-cancel":"icon-cancel"};


//////////////////
// WEBPACK FOOTER
// ./src/template/Floats/StudentInfoFloat/StudentInfoFloat.scss
// module id = PcKN
// module chunks = 0